import { Controller } from '@hotwired/stimulus';

export default class ChartsSwitcherController extends Controller {
  static targets = ['card'];
  static values = { current: String };

  select(event) {
    this.currentValue = event.target.value;
  }

  currentValueChanged() {
    this.cardTargets.forEach((card) => {
      const isSelected = card.dataset.chartKey === this.currentValue;
      card.classList.toggle('d-none', !isSelected);
    });
  }
}
